import moment from "moment";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import { BiosimilarConfigDoc } from "../types";

const COLLECTION_PATH = "api_config/pharmacy/cmm-biosimilar-families";
const DOC_ID = "v1";

/**
 * Loads the biosimilar families config document from Firestore.
 *
 * @returns Parsed document, or null when missing
 */
export const fetchBiosimilarConfig = async (): Promise<BiosimilarConfigDoc | null> => {
  const path = FirestoreDocumentReference.cmmBiosimilarFamilies();
  return FirestoreService.getDocumentOrNull<BiosimilarConfigDoc>(path);
};

/**
 * Persists the biosimilar families config document, stamping save audit fields.
 *
 * @param data - Full document payload to write
 * @param updatedBy - Email of the user performing the save
 */
export const saveBiosimilarConfig = async (
  data: BiosimilarConfigDoc,
  updatedBy: string,
): Promise<void> => {
  const { id: _id, ...fields } = data;
  await FirestoreService.updateDocument(COLLECTION_PATH, DOC_ID, {
    ...fields,
    updated_by: updatedBy,
    updated_at: moment().toDate().toISOString(),
  });
};
